module.exports = __webpack_public_path__ + "img/revision.55568983.png";